/* GASSISA
=========================================================================================
 * Descripcion: Autocomplete del sistema. Es el unico Autocomplete que se
 *              debe importar en toda la aplicacion: inyecta en el
 *              renderInput los atributos que desactivan el autocompletado
 *              del navegador en el <input> nativo (ver components/ui/TextField.jsx)
 *              para evitar las ventanas emergentes de autocompletado.
 *              El renderInput del caller sigue recibiendo params con los
 *              atributos ya incluidos; si redefine inputProps, sus valores
 *              ganan sobre los defaults de aqui.
 * Historial de cambios:
 * ---------------------------------------------------------------------------------------
 *    Revisión   | Fecha      | Desarrollador                    | Resumen del cambio
 * ---------------------------------------------------------------------------------------
 *      1       | 06/10/2026 | LIC. José Luis Aragón C.                       | Creación
 * ---------------------------------------------------------------------------------------
 */

import { Autocomplete as MuiAutocomplete } from "@mui/material";
import TextField from "./TextField";

const ATRIBUTOS_ENTRADA = {
    autoComplete: "off",
    autoCorrect: "off",
    autoCapitalize: "off",
    spellCheck: "false",
};

export default function Autocomplete(props) {
    const { renderInput, ...resto } = props;
    return (
        <MuiAutocomplete
            {...resto}
            renderInput={(params) => {
                const paramsConDefaults = {
                    ...params,
                    inputProps: {
                        ...ATRIBUTOS_ENTRADA,
                        ...params.inputProps,
                    },
                };
                if (renderInput) {
                    return renderInput(paramsConDefaults);
                }
                return <TextField {...paramsConDefaults} />;
            }}
        />
    );
}
